import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Loader from '../../shared/loader';

class StateField extends Component {
    constructor(props) {
        super(props);

        this.handleStateChange = this.handleStateChange.bind(this);
    }

    handleStateChange(event) {
        this.props.handleStateChange(event.currentTarget.value);
        // Trigger the redux-form onChange callback.
        this.props.input.onChange(event.currentTarget.value);
        this.props.input.onBlur();
    }

    render() {
        const { meta: { touched, error } } = this.props;
        let errorClassName = '';
        if (touched && error) {
            errorClassName = 'has-error ';
        }

        const stateOptionsMarkup = this.props.states.map((state, idx) => (
            <option key={idx} value={state.abbr}>
                {state.name}
            </option>
        ));

        return (
            <div style={{ position: 'relative' }} className={`${errorClassName}`}>
                {!this.props.displayLoader ? (
                    <select
                        name={`${this.props.fieldNamePrefix}[state_name]`}
                        onChange={this.handleStateChange}
                        className="form-control primary-input-field"
                        value={this.props.selectedStateCode}
                        disabled={(!this.props.displayLoader && this.props.states.length === 0) || this.props.disabled}
                    >
                        <option value="" disabled>{this.props.intl.formatMessage({ id: 'select', defaultMessage: 'Select' })}</option>
                        { stateOptionsMarkup }
                    </select>
                ) : (
                    <select
                        name={`${this.props.fieldNamePrefix}[state_name]`}
                        onChange={this.handleStateChange}
                        className="form-control primary-input-field"
                        value={this.props.selectedStateCode}
                        disabled={(!this.props.displayLoader && this.props.states.length === 0) || this.props.disabled}
                    >
                        <option value="" />
                    </select>
                )}

                <div style={{
                    position: 'absolute', top: '5px', right: '4px', backgroundColor: !this.props.displayLoader && this.props.states.length === 0 ? '#eee' : '#fff',
                }}
                >
                    <Loader displayLoader={this.props.displayLoader} size={25} />
                </div>
                {touched && error && <span className="help-block">{error}</span>}
            </div>
        );
    }
}

export default injectIntl(StateField);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/address/state-field.jsx
 **/